<template>
  <div class="describe_image">
    <precautions
      v-if="selectedStep === 0"
      :title="questionData.Name"
      :level="level"
      :unit="unit"
      :questionData="questionData"
    />

    <!-- START 按鈕 -->
    <div class="d-flex justify-content-center mt-3" v-if="selectedStep === 0">
      <a
        class="d-inline-block gept_main_bg4 text-white px-5 py-2 rounded-pill mx-auto pointer font-weight-bold"
        @click="getStart()"
      >
        START
      </a>
    </div>

    <!-- 主體 -->
    <div v-if="selectedStep === 1" class="describe_image_inner">
      <div class="d-flex justify-content-between align-items-center bg-white mb-3 p-1 w-100">
        <div class="d-flex align-items-center">
          <p class="h6 font-weight-bold gept_main_color p-2 mb-0">
            Question 1/{{ questionData.Questions.length }}
          </p>
        </div>
        <div class="p-2 rounded text-lg w-20 text-right border-1 gept_main_color4 border_main2 font-semibold text-nowrap">
          {{ answer_count }} s
        </div>
      </div>

      <div class="pt-2 d-flex flex-wrap">
        <!-- 題目列表 -->
        <div class="order-2 order-lg-1 px-2 px-lg-0 col-12 col-lg-8">
          <div
            v-for="(item, index) in questionData.Questions"
            :key="index"
            class="teacher_answer mb-3 d-flex rounded overflow-hidden pointer"
            @click="selectItem(index)"
            :class="{ 'pointer': isCanActive }"
          >
            <div
              class="gept_main_bg5 text-white d-flex align-items-center justify-content-center w-16 text-center"
              :class="{ 'gept_main_bg6': isCanActive && selectedIdx !== index, 'gept_main_bg5': isCanActive && selectedIdx === index }"
            >
              {{ arr[index] }}
            </div>

            <div class="flex-1 bg-white p-2 py-3">
              <div class="bg-white mb-2 mx-auto" style="max-width: 36rem;">
                <img class="mx-auto d-block img-fluid object-contain" :src="item.ImageUrl" alt="">
              </div>
              <p
                class="text-lg mb-0 text-left"
                :class="{ 'gept_main_color8 pointer': isCanActive, 'text-black font-weight-bold': isCanActive && selectedIdx === index }"
                v-html="item.Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"
              ></p>
            </div>

            <div class="bg-white d-flex align-items-center justify-content-center" v-if="ERS_arr.length > 0">
              <img
                class="mx-auto img-fluid w-50 opacity-0 object-contain"
                :class="{ 'opacity-100': !isEmpty(ERS_arr[index]) }"
                src="@/assets/image/gept/icon_check.png"
                alt=""
              >
            </div>
          </div>
        </div>

        <!-- 錄音區 -->
        <div class="order-1 order-lg-2 mb-2 mb-lg-0 col-12 col-lg-4">
          <div class="h-100 w-100 item-outer">
            <div
              class="bg-white h-100 d-flex flex-column justify-content-between align-items-center rounded item_border position-relative pointer border-1"
              :class="{ 'border-4 border_main2': isCanActive || showStage === 1 }"
            >
              <div class="w-100">
                <div class="p-2 w-100 mb-4 text-center">
                  <p
                    v-if="showStage === 0 && !isNotEmpty(ERS_arr) && answer_count > 0"
                    class="font-weight-bold gept_main_color6 h5 py-1 mb-0"
                    :class="{ 'gept_main_color4': isCanActive }"
                  >
                    回答
                  </p>
                  <p
                    v-if="!showStage === 0 && isNotEmpty(ERS_arr) && answer_count > 0"
                    class="font-weight-bold gept_main_color6 h5 py-1 mb-0"
                  >
                    錄音完成
                  </p>
                  <p
                    v-if="answer_count === 0"
                    class="font-weight-bold gept_main_color6 h5 py-1 mb-0"
                  >
                    作答時間已到，請交卷
                  </p>
                  <p
                    v-if="showStage === 1 && !isNotEmpty(ERS_arr) && answer_count > 0"
                    class="text-white gept_main_bg5 w-100 text-center h5 py-1 mb-0"
                  >
                    正在錄製 S{{ selectedIdx + 1 }}
                  </p>
                </div>

                <div class="item_img p-2 d-flex flex-column align-items-center justify-content-center">
                  <Recognition :showStage="showStage" v-on:emitAudioData="emitAudioData" class="mb-2" />
                  <a
                    @click="skipCountDown()"
                    class="d-inline-block gept_main_bg5 text-white px-4 py-2 rounded mx-3 pointer font-weight-bold mb-4 opacity-0 text-center"
                    :class="{ 'opacity-100': answer_count > 0 && timer && !isCanActive && isReadingStatus }"
                  >
                    跳過倒數，開始作答
                  </a>
                </div>
              </div>

              <div
                class="p-4 w-100 item_text d-flex align-items-center justify-content-center border-t border-4"
                :class="{
                  'border-t border_main2': (isCanActive || isRecording) && answer_count > 0,
                  'border-t border_main6': (isNotEmpty(ERS_arr) && answer_count > 0) || answer_count === 0
                }"
              >
                <p
                  class="gept_main_color6 h6 text-center font-weight-bold mb-0"
                  v-if="!isCanActive && isReadingStatus"
                >
                  請先閱讀題目，閱讀時間結束倒數時，麥克風將會自動開啟錄音，請在時間內回答完成。
                </p>
                <p
                  class="gept_main_color4 h6 text-center font-weight-bold mb-0"
                  v-if="isCanActive && !isNotEmpty(ERS_arr) && answer_count > 0 && !isReadingStatus"
                >
                  唸完請點選停止鍵。
                </p>

                <div v-if="isNotEmpty(ERS_arr) || answer_count === 0">
                  <a
                    @click="toggleReport()"
                    class="btn-default gept_main_bg5 text-white m-2 d-inline-block pointer"
                  >
                    {{ !isLastGroup && $route.name === 'formal_exam' ? '前往下一個題型' : '交卷看報告' }}
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  // import api from '@/store/api'
  import precautions from '@/components/AiHelper/GEPT/precautions'
  import Recognition from '@/components/AiHelper/GEPT/Recognition'
  import allJs from '@/components/AiHelper/all.js'
  import formal_examJs from '@/components/AiHelper/examJs_gept.js'
  export default {
    name: 'describe_image',

    data () {
      return {
        arr: ['ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN'],
        selectedStep: 0,

        selectedIdx: -1,

        showStage: 0,

        isCanActive: false,
        isReadingStatus: true,

        isRecording: false,
        // 正在倒數中
        isCountingExam: false,

        answer_count: 30,
        timer: null,

        ERS_arr: []
      }
    },
    props: {
      questionData: {
        type: Object
      },
      unitTitle: {
        type: String
      },
      unit: {
        type: String
      },
      isLastGroup: {
        type: Boolean,
        default: false
      },
      level: {
        type: String
      },
      secondsData: {
        type: Object
      }
    },
    mixins: [
      allJs,
      formal_examJs
    ],
    components: {
      precautions,
      Recognition
    },
    computed: {
      sText () {
        let self = this
        if (self.selectedIdx > -1) {
          return self.questionData.Questions[self.selectedIdx].Title
        }
        return ''
      },
      testData () {
        let self = this
        if (localStorage.getItem(self.$route.params.select_id) && JSON.parse(localStorage.getItem(self.$route.params.select_id)).describe_image) {
          return JSON.parse(localStorage.getItem(self.$route.params.select_id)).describe_image
        }
        return []
      }
    },
    created () {
      this.answer_count = this.secondsData.preRead
    },
    mounted () {
      this.initErsArr()

      this.$emit('setIsStart', false)
    },
    methods: {
      getStart () {
        this.selectedStep = 1

        this.countDown()

        this.$emit('setIsStart', true)
      },

      initErsArr () {
        let self = this
        if (self.questionData) {
          let arrLength = self.questionData.Questions.length

          self.ERS_arr = new Array(arrLength).fill({})
        }
      },
      // step1
      countDown () {
        let self = this
        if (!self.isCanActive) {
          self.timer = setInterval(() => {
            self.answer_count--
            if (self.answer_count === 0) {
              self.isCanActive = true
              self.isReadingStatus = false
              clearInterval(self.timer)

              self.$nextTick(() => {
                self.answer_count = self.secondsData.exam
                self.startExam()
              })
            }
          }, 1000)
        } else {
          self.timer = setInterval(() => {
            self.answer_count--
            if (self.answer_count === 0) {
              self.isCanActive = false
              self.showStage = 2
              clearInterval(self.timer)
            }
          }, 1000)
        }

      },

      skipCountDown () {
        let self = this

        if (self.answer_count > 0 && self.timer && !self.isCanActive && self.isReadingStatus) {
          self.isCanActive = true
          self.isReadingStatus = false
          self.answer_count = self.secondsData.exam

          clearInterval(self.timer)

          self.$nextTick(() => {
            self.startExam()
          })
        }
      },

      startExam () {
        let self = this
        if (self.answer_count > 0 && self.isCanActive) {
          self.selectedIdx = 0
          self.showStage = 1

          self.answer_count = self.secondsData.exam

          self.$nextTick(() => {
            self.countDown()
          })
        }
      },

      selectItem (index) {
        let self = this
        if (self.answer_count > -1 && self.isCanActive && !self.ERS_arr[index].audio) {
          self.selectedIdx = index

          self.showStage = 1
        }
      },

      // step2
      async emitAudioData (emitAudioData) {
        let self = this
        self.showStage = 0

        let result

        if (self.$route.name === 'practice_speaking') {
          result = await self.post_records_by_AIETA(self.$route.params.select_id, self.questionData.Questions[self.selectedIdx].Id, self.questionData.Name, self.questionData.Questions[self.selectedIdx].Title, emitAudioData)
        } else {
          result = await self.post_gept_records_byFormal(self.$route.query.record_id, self.questionData.Questions[self.selectedIdx].Id, self.questionData.Name, self.questionData.Questions[self.selectedIdx].Title, emitAudioData)
        }

        if (result) {
          self.showStage = 0

          self.ERS_arr[self.selectedIdx] = result

          if (self.selectedIdx < self.questionData.Questions.length) {
            self.selectItem(self.selectedIdx++)
          }
          if (self.isNotEmpty(self.ERS_arr)) {
            self.isCanActive = false
            clearInterval(self.timer)
          }
        }
      },
      // step3
      async toggleReport () {
        let self = this
        // eslint-disable-next-line
        let isGuideLink = (self.isLastGroup && self.$route.name === 'formal_exam') || (self.$route.name === 'practice_speaking') ? true : false

        if (self.ERS_arr.length === self.questionData.Questions.length) {
          if (self.$route.name === 'practice_speaking' && await self.checkSubmitReport(self.unitTitle, self.questionData.Name)) {
            self.finish_exams(self.$route.params.select_id, self.questionData.Name, isGuideLink)
          } else if (self.$route.name === 'formal_exam' && !self.isLastGroup) {
            self.$nextTick(() => {
              self.$emit('guideNextType')
            })
          } else if (self.$route.name === 'formal_exam' && self.isLastGroup) {
            self.post_gept_records_finish(self.$route.query.record_id)
          }
        }
      },

      isEmpty (obj) {
        return Object.keys(obj).length === 0
      },
      isNotEmpty (array) {
        let isNotEmptyFunc = (obj) => {
          return Object.keys(obj).length !== 0;
        }

        return array.every(isNotEmptyFunc)
      },

      reStart () {
        Object.assign(this.$data, this.$options.data())
      }
    }
  }
</script>

<style lang="scss" scoped>
.describe_image {
  .border-t {
      border-top: 1px solid #dee2e6;
  }
  .border-4 {
      border-width: 4px;
  }
  .border-t-4 {
      border-top-width: 4px !important;
  }
  .w-20 {
      width: 5rem !important;
  }
  .describe_image_inner {
    .col {
      flex: 1;
    }
    .item-outer2 {

    }
    .item-outer3 {
    }
    .active {

    }
    .play-voice {
      right: 10%;
      bottom: 10%;
      z-index: 2;
      @media (max-width: 1024px) {
        right: 0%;
        bottom: 0%;
      }
      @media (max-width: 640px) {
        right: 10%;
        bottom: 10%;
      }
    }
    .item_border_arrow_active{
      &:after {
        background-image: url('~@/assets/image/gept/arrow_active.jpg') !important;
      }
    }
    .item_img {
      min-height: 320px;
      @media (max-width: 768px) {
        min-height: auto;
      }
      .check {
        top: 45%;
        left: 50%;

        transform: translate(-50%, -50%);
      }
    }
    .item_text {
      min-height: 120px;
      height: 20%;
      @media (max-width: 1024px) {
        height: auto;
      }
    }
  }
}
</style>
